import { render, staticRenderFns } from "./SignUpFeatureList.vue?vue&type=template&id=e534d3ac&"
import script from "./SignUpFeatureList.vue?vue&type=script&lang=js&"
export * from "./SignUpFeatureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports